import React from 'react';
import Image4 from '../../../assets/images/simulation/bio/12/01/bio4.jpg';

const BioProcedureTemplate = () => {
  return (
    <div className="flex flex-wrap text-lg font-body text-gray-900 leading-relaxed tracking-wide px-4 py-5">
      {/* Main Content */}
      <div className="mb-1">
        <h2 className="font-semibold"> প্রয়োজনীয় যন্ত্রপাতি: </h2>
        <img src={Image4} alt="simulation-theory" className="py-1" />
      </div>

      {/* Procedure 1 */}
      <div className="mt-5">
        <h2 className="font-semibold mb-2"> ল্যাব এর কার্যধারা </h2>
        <p className="mb-2">
          একটি স্বাস্থ্যকর পাত্রযুক্ত উদ্ভিদ নিন এবং এটি 2-3 দিনের জন্য একটি
          অন্ধকার জায়গায় রাখুন, এটি পাতাগুলিকে বাদ দেয়।
        </p>
        <ul className="list-inside leading-loose list-disc">
          <li>কালো কাগজের দুটি অভিন্ন স্ট্রিপ কেটে ফেলুন।</li>
          <li>
            কাগজের ক্লিপ ব্যবহার করে পাতার কালো কাগজের উভয় প্রান্ত ঠিক করুন।
          </li>
          <li>এখন, পাত্রের গাছটিকে সারাদিনের জন্য সূর্যের আলোতে রাখুন।</li>
          <li>
            শেষ বিকেলে আচ্ছাদিত পাতাটি উপড়ে নিন এবং পাতা থেকে কালো কাগজটি
            সরিয়ে ফেলুন।
          </li>
          <li>
            পাতিত জলযুক্ত একটি বীকার নিন এবং এটি একটি গরম প্লেটের উপরে রাখুন এবং
            জল ফুটান।
          </li>
          <li>
            হট প্লেট থেকে বীকারটি সরান এবং কিছু সময়ের জন্য ঠান্ডা হতে দিন।
          </li>
          <li>
            পাতিত জল ধারণকারী আরেকটি বিকার নিন এবং এটি হট প্লেটের উপরে রাখুন এবং
            এটি প্রায় 60oC তাপমাত্রায় ফুটিয়ে নিন।
          </li>
          <li>একটি পরিষ্কার ফুটন্ত টিউব মধ্যে কিছু অ্যালকোহল ঢেলে দিন।</li>
          <li>ফুটন্ত টিউবটি বীকারে সিদ্ধ করা জল দিয়ে রাখুন।</li>
          <li>ফোর্সেপ ব্যবহার করে বীকার থেকে পাতাটি সরান।</li>
          <li>অ্যালকোহলযুক্ত ফুটন্ত নলটিতে পাতাটি রাখুন। </li>
          <li> পাতা বর্ণহীন হওয়া পর্যন্ত ফুটন্ত টিউবটি বিকারে রাখুন।</li>
          <li>ফোর্সেপ ব্যবহার করে ফুটন্ত নল থেকে পাতাটি সরান। </li>
          <li>পাতিত জলযুক্ত একটি বিকারে পাতাটি ডুবিয়ে ধুয়ে ফেলুন। </li>
          <li> এবার পাতাটি একটি পেট্রি ডিশে রাখুন।</li>
          <li>
            একটি ড্রপার ব্যবহার করে কয়েক ফোঁটা আয়োডিনের দ্রবণ নিন এবং এই ফোঁটা
            পাতায় ঢেলে দিন।
          </li>
        </ul>
      </div>

      {/* Procedure 2 */}
      <div className="mt-5">
        <h2 className="font-semibold mb-1">পর্যবেক্ষণ</h2>
        <ul className="list-inside leading-loose list-disc">
          <li>
            আয়োডিন চিকিত্সার পরে, পাতার উন্মুক্ত অংশের রঙ নীল-কালো হয়ে যায়।
          </li>
          <li>পাতার অপ্রকাশিত অংশের রঙ ফ্যাকাশে হলুদ-বাদামী হয়ে যায়।</li>
        </ul>
      </div>

      {/* Procedure 3 */}
      <div className="mt-5">
        <h2 className="font-semibold mb-1">পর্যবেক্ষণ</h2>
        <p>
          আমরা জানি যে স্টার্চ হল সালোকসংশ্লেষণের শেষ পণ্যগুলির মধ্যে একটি এবং
          আমাদের পর্যবেক্ষণ দেখায় যে সূর্যের আলোর সংস্পর্শে শুধুমাত্র পাতার সেই
          অংশগুলিই আয়োডিনের সংস্পর্শে নীল-কালো হয়ে যায়। যেহেতু স্টার্চ
          আয়োডিনের সংস্পর্শে নীল-কালো হয়ে যায়, তাই পাতার যে অংশগুলো নীল-কালো
          হয়ে গেছে তা সালোকসংশ্লেষের ক্রিয়াকলাপের ইঙ্গিত দেয়, যখন অপ্রকাশিত
          অংশ বিপরীতটি দেখায়। এটি স্পষ্টভাবে নির্দেশ করে যে সালোকসংশ্লেষণের
          জন্য আলো অপরিহার্য।
        </p>
      </div>

      {/* Procedure 4 */}
      <div className="mb-6 mt-5">
        <h2 className="font-semibold mb-1">সতর্কতা</h2>
        <ul className="list-inside leading-loose list-disc">
          <li>পরীক্ষামূলক পাতা স্বাস্থ্যকর হতে হবে।</li>
          <li>
            কালো কাগজটি সাবধানে পাতায় ক্লিপ করুন, যাতে আচ্ছাদিত অংশটি সূর্যের
            আলো না পায়।
          </li>
          <li>অ্যালকোহলে পাতা সিদ্ধ করার পর পানিতে ধুয়ে ফেলতে হবে।</li>
        </ul>
      </div>
    </div>
  );
};

export default BioProcedureTemplate;
